import { LightningElement, wire } from "lwc";
import mobileAppIconSvg from "../../common/assets/mobile-app-icon.svg";
import mobileAppStoreSvg from "../../common/assets/mobile-app-store.svg";
import mobileGooglePlaySvg from "../../common/assets/mobile-google-play.svg";
import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";
import * as locales from "./locales";
import { getAssetsUrl } from "common/helpers";
import { getLocale } from "@devforce/trailhead-client-locale";
import { trackUserActivity, type UserActivityEvents } from "common/track";

export default class DownloadMobileAppPage extends LightningElement {
  @wire(LabelsAdapter, { locales })
  private labels: LabelsAdapterValue = {};

  private get appStoreImg() {
    return getAssetsUrl(mobileAppStoreSvg);
  }

  private get googlePlayImg() {
    return getAssetsUrl(mobileGooglePlaySvg);
  }

  private get mobileAppIcon() {
    return getAssetsUrl(mobileAppIconSvg);
  }

  private get mobileUrl() {
    return `/${getLocale()}/mobile`;
  }

  private onClick(e: MouseEvent) {
    e.preventDefault();
    const target = e.currentTarget as HTMLElement;
    const ctaType = target?.dataset?.ctaType;

    this.track("celebration_cta_clicked", ctaType);
    window.open(this.mobileUrl, "_blank");
  }

  private track(
    eventName: keyof UserActivityEvents,
    ctaType: string | undefined
  ) {
    trackUserActivity(this, eventName, {
      pageLocation: "th-download-mobile-app-page",
      type: ctaType,
    });
  }
}
